var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.totalItems > 0)?_c('div',{staticClass:"hiq-previous-exhibitions-boxes"},[_c('h1',{staticClass:"hiq-previous-exhibitions-boxes__title"},[_vm._v(_vm._s(_vm.title))]),_c('EventList'),_c('AmountHitsShowing'),(_vm.amountShowing < _vm.totalItems)?_c('ShowMore'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }